import * as React from 'react';

import { getContainerHOC, renderChildren } from '@utils';

import { Translate } from '@decorators';

import { AppStat } from '@common/utils/AppStat';

import { IDmcaChildProps, IDmcaProps } from './types';

@Translate('common.containers.Dmca')
export class Dmca extends React.Component<IDmcaProps> {

	componentDidMount() {
		AppStat.log.boom.openBoomDmca();
	}

	render() {
		const { children } = this.props;

		return renderChildren<IDmcaChildProps>(children, {});
	}

}

export const withDmcaContainer = getContainerHOC<IDmcaProps, IDmcaChildProps>(Dmca);
